import Vue from 'vue'
import axios from 'axios'
import factory from '../factory'

const module = factory('Clubs')

// Soft-deleted clubs are kept in their own list so the regular one stays the
// active clubs only, and both can be shown from /clubs.
module.state.deleted = []

module.getters.deletedList = state => state.deleted || []

module.actions.loadDeleted = async ({ commit }) => {
  try {
    const response = await axios.get('model/Clubs', { params: { deleted: 1 } })
    if (!response.data) throw new Error(response.data)
    commit('setDeleted', response.data)
    return response.data
  } catch (e) {
    commit('setDeleted', [])
    return Promise.reject(e)
  }
}

module.actions.restore = async ({ commit }, id) => {
  const response = await axios.post(`model/Clubs/${id}/restore`)
  if (response.data?.success) {
    commit('removeDeleted', id)
    if (response.data.item) {
      commit('update', response.data.item)
      commit('setSingle', response.data.item)
    }
  }
  return response.data
}

module.mutations.setDeleted = (state, data) => {
  Vue.set(state, 'deleted', Array.isArray(data) ? data : [])
}

module.mutations.removeDeleted = (state, id) => {
  if (!Array.isArray(state.deleted)) return
  const idx = state.deleted.findIndex(item => parseInt(item.id) === parseInt(id))
  if (idx >= 0) state.deleted.splice(idx, 1)
}

export default module
